import { SellOffer } from "../entity/SellOffer";
import { DiffBenchmark } from "./DiffBenchmark";
import { SavingsInfo } from "./SavingsInfo";
import { Stats } from "./Stats";


export class OffersData {
    offer: SellOffer;
    priceStats: Stats | null;
    savings: { [id in DiffBenchmark]: SavingsInfo };
}
